{
  "version": 1,
  "asset_id": "9d93238a-54b2-4285-851a-c0a129e403de",
  "project_id": "7ac59465-c0f2-4b6e-9949-d18c7a8fae04",
  "url": "/__l5e/assets-v1/9d93238a-54b2-4285-851a-c0a129e403de/brand-160.png",
  "r2_key": "a/v1/7ac59465-c0f2-4b6e-9949-d18c7a8fae04/9d93238a-54b2-4285-851a-c0a129e403de/brand-160.png",
  "original_filename": "brand-160.png",
  "size": 21965,
  "content_type": "image/png",
  "created_at": "2026-06-25T01:16:13Z"
}
